import { useMeta, useContext, useRoute } from '@nuxtjs/composition-api';
import { mergeHeadItems } from '~/modules/common/utils/helpers';
import { getMetaOpenGraph, getMetaTwitter } from '~/modules/common/utils/metaUtils';
import { HOST_URL, PROFILE_PATH, COMMENTS_PATH } from '~/constants/config';

export function useProfileMeta({ userData }) {
  const route = useRoute();
  const { i18n } = useContext();

  const checkExcludePath = () => {
    const result = ['favoriler', 'takip-ettikleri', 'takipciler'].filter((v) => route.value.path.includes(v));
    return !result.length;
  };

  useMeta(() => {
    const title = `${userData.value.user?.name || userData.value.user?.username || i18n.t('profile.not-found')} - Onedio`;
    if (!userData.value.user) return;
    const profileName = userData.value.user?.name || userData.value.user?.username;
    const url = `${HOST_URL}/${PROFILE_PATH}/${
      route.value.fullPath.includes(COMMENTS_PATH) ? userData.value.user?.username + '/' + COMMENTS_PATH : userData.value.user?.username
    }`;
    const description = i18n.t('meta.profile', { profileName });
    const metaOpeGraph = getMetaOpenGraph({
      url,
      description,
      title,
    });
    const metaTwitter = getMetaTwitter({ url, description, title });
    const meta = [{ hid: 'description', name: 'description', content: description }, ...metaOpeGraph, ...metaTwitter];
    const link = [];
    if (checkExcludePath()) {
      if (userData.value.user?.stats?.articles < 5) {
        meta.push({ hid: 'robots', name: 'robots', content: 'noindex' });
      } else {
        link.push({ hid: 'canonical', name: 'canonical', rel: 'canonical', href: url });
      }
    }
    return mergeHeadItems({ title }, { meta }, { link });
  });
}
